import { graphql } from 'react-relay';
export const CollabDraftQuery = graphql`
	query CollabDraftQuery($id: ID!, $draftShareId: String = "", $hydrateAdf: Boolean) {
		collabDraft(id: $id, draftShareId: $draftShareId, hydrateAdf: $hydrateAdf) {
			document
			version
			metadata {
				title
			}
		}
	}
`;
